import React from "react";
import ReactDOM from "react-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AccountProvider } from "auth/accountProvider";
import { AppProvider } from "appProvider";
import { queryClient } from "lib/queryClient";
import App from "./App";
import "./i18n/config";

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <AccountProvider>
          <App />
        </AccountProvider>
      </AppProvider>
      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
